import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, SearchIcon, PenToolIcon, BarChart2Icon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid2Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2211">
      <SEO data-id="element-2212" />
      <Header data-id="element-2213" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2214">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2215">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2216">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2217" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2218">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2219">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2220">
                <img src="https://cdn.magicpatterns.com/uploads/3h5jPU9M1S7oTcbxfUFYhr/image.png" alt="Beer" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2221" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2222">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2223">
                Beer
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2224">
                SEO Specialist
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2225">
                <p className="mb-4" data-id="element-2226">
                  Als SEO Specialist bij Noord Digital ben ik verantwoordelijk
                  voor de organische vindbaarheid van onze klanten. Mijn doel is
                  niet alleen om websites hoger in Google te krijgen, maar
                  vooral om de juiste, koopgerichte bezoekers aan te trekken.
                </p>
                <p className="mb-4" data-id="element-2227">
                  Ik duik diep in de data om te begrijpen waar de doelgroep naar
                  zoekt en welke intentie daarachter zit. Op basis daarvan bouw
                  ik ijzersterke SEO-structuren en contentstrategieën die op de
                  lange termijn structureel leads opleveren.
                </p>
                <p data-id="element-2228">
                  Mijn werkwijze kenmerkt zich door een technische basis
                  gecombineerd met sterke, relevante content. Ik geloof dat SEO
                  geen trucje is, maar het bouwen van de beste antwoorden op de
                  vragen van je potentiële klanten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2229">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2230">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2231">
                  <SearchIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2232" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2233">SEO Strategie</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2234">
                  <PenToolIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2235" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2236">
                    Content Marketing
                  </h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2237">
                  <BarChart2Icon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2238" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2239">Keyword Research</h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2240">
                Neem contact op met Beer
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2241" />
    </div>;
};